import Image from 'next/image';
import Link from 'next/link';

import { Box, Heading, Paragraph } from '@zillow/constellation-10';

import { CELEBRATE_ILLUSTRATION_URL } from '../../../../../constants/DigitalLibraryConstants';
import { ROUTES } from '../../../../../constants/urls';

export const ThanksPage = () => {
  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap: '600',
        alignItems: 'flex-start',
        width: '100%',
      }}
    >
      <Box aria-hidden="true">
        <Image priority src={CELEBRATE_ILLUSTRATION_URL} alt="" width={120} height={120} />
      </Box>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: '200' }}>
        <Heading level={2} textStyle="heading-xs">
          Thanks for sharing
        </Heading>
        <Paragraph>
          We’ll use your answers to tailor your experience. Go to your{' '}
          <Link href={ROUTES.ACCOUNT_SETTINGS}>account settings page</Link> anytime you need to update your role or the
          number of units you manage.
        </Paragraph>
      </Box>
    </Box>
  );
};

export default ThanksPage;
